module.exports = __webpack_public_path__ + "static/media/Heineken-00-No-white-Background.5b83734c.png";